import { PaymentProvider } from '@wix/cashier-common/dist/src/enums/payments/PaymentProvider';

export const isWixPay = (providerId: PaymentProvider) => providerId === PaymentProvider.WixPayUS;
